// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { loginWithMagicLink } from '@/authentication/api/login-with-magic-link';
import { useMutation } from '@tanstack/react-query';

/** Signs in with the id from an emailed sign-in link. */
export function useMagicLinkLogin() {
  return useMutation({
    mutationFn: (linkID: string) => loginWithMagicLink(linkID),
  });
}
